module.exports = __webpack_public_path__ + "static/media/falower.a89e3af4.png";